import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import {
  MinorAccountAcceptComponent,
  MinorAccountInviteComponent,
  MinorAccountInviteSentComponent,
  MinorAccountNotFoundComponent,
  MinorAccountRepeatComponent,
} from '@se-po/se-household-setup-feature-minor-account-invite'
import { MinorAccountComponent } from './minor-account.component'

const routes: Routes = [
  {
    path: '',
    component: MinorAccountComponent,
    children: [
      { path: '', redirectTo: 'not-found', pathMatch: 'full', },
      { path: 'not-found', component: MinorAccountNotFoundComponent },
      { path: 'invite/sent', component: MinorAccountInviteSentComponent },
      { path: 'invite/:id', component: MinorAccountInviteComponent },
      { path: 'accept/:id', component: MinorAccountAcceptComponent },
      { path: 'repeat/:id', component: MinorAccountRepeatComponent },
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class MinorAccountRoutingModule { }
